<template>
  <div>
    <div class="primary--text" v-if="!isEdit">
      <v-layout>
        <v-flex class="pa-1"
          >{{ value.min | decimalFormat }} {{ $t('gram') }} - {{ value.max | decimalFormat }}
          {{ $t('gram') }}</v-flex
        >
        <v-flex class="pa-1 text-xs-right">
          <template v-if="value.charge != 0"
            >฿{{ value.charge | decimalFormat }}</template
          >
          <template v-else>{{ $t('Free') }}</template>
        </v-flex>
      </v-layout>
    </div>

    <v-layout v-else>
      <v-flex class="form-control pa-1">
        <input
          class="mb-0"
          type="number"
          pattern="[0-9]*"
          inputmode="numeric"
          v-model.number="value.min"
          name="weight_min"
          :data-vv-name="'weight_min_' + position"
          :placeholder="$t('Min weight')"
          :data-vv-as="$t('Min weight')"
          v-validate="position == 0 ? 'required|decimal:2|min_value:0' : 'required'"
          :disabled="position != 0"
          @blur="onBlur"
        />
      </v-flex>
      <v-flex class="text-xs-center pt-3">-</v-flex>
      <v-flex class="form-control pa-1">
        <input
          class="mb-0"
          type="number"
          pattern="[0-9]*"
          inputmode="numeric"
          v-model.number="value.max"
          name="weight_max"
          :data-vv-name="'weight_max_' + position"
          :placeholder="$t('Max weight')"
          :data-vv-as="$t('Max weight')"
          v-validate="'required|decimal:2|min_value:' + value.min"
          @blur="onBlur"
        />
      </v-flex>
      <v-flex class="form-control pa-1">
        <input
          class="mb-0"
          type="number"
          pattern="[0-9]*"
          inputmode="numeric"
          v-model.number="value.charge"
          name="weight_charge"
          :data-vv-name="'weight_charge_' + position"
          :placeholder="$t('shipping fee')"
          :data-vv-as="$t('shipping fee')"
          v-validate="'required|decimal:2|min_value:0'"
          @blur="onBlur"
        />
      </v-flex>
      <v-flex>
        <v-btn fab small flat class="extra-small ma-0" color="primary" @click="$emit('onDelete')">
          <v-icon>delete</v-icon>
        </v-btn>
      </v-flex>
    </v-layout>

    <div class="form-control has-error">
      <span class="text-error" v-if="errors.has('weight_min_' + position)">{{
        errors.first('weight_min_' + position)
      }}</span>
      <span class="text-error" v-else-if="errors.has('weight_max_' + position)">{{
        errors.first('weight_max_' + position)
      }}</span>
      <span class="text-error" v-else-if="errors.has('weight_charge_' + position)">{{
        errors.first('weight_charge_' + position)
      }}</span>
    </div>
  </div>
</template>

<script>
import { Validator } from 'vee-validate'
import InputDecimal from '@/components/elements/InputDecimal'

const paramNames = ['price']
const isLess = (value, { price } = {}) => {
  try {
    if (parseFloat(price) > 0) {
      return parseFloat(value) < parseFloat(price)
    } else {
      return true
    }
  } catch (error) {
    return false
  }
}
Validator.extend(
  'isShippingWeightPriceLessThan',
  {
    validate: isLess,
    getMessage: field => 'Price must be cheaper than previous price'
  },
  { paramNames }
)
export default {
  props: {
    value: { default: undefined },
    isEdit: { default: false },
    minWeight: { default: null },
    lastPrice: {
      default: 0
    },
    position: { default: 0 }
  },
  inject: ['$validator'],
  components: {
    InputDecimal
  },
  mounted() {
    if (this.position > 0) {
      this.value.min = this.roundNumber(this.minWeight + 0.01)
    }
  },
  methods: {
    onBlur() {
      this.$emit('input', this.value)
      this.$emit('onChangeValue')
    }
  },
  watch: {
    value: function() {
      if (this.value) {
        if (this.position > 0) {
          this.value.min = this.roundNumber(this.minWeight + 0.01)
        }
      }
    },
    minWeight: function() {
      if (this.position > 0) {
        this.value.min = this.roundNumber(this.minWeight + 0.01)
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/setting/ecommerce/ShippingDetailWeight.vue